import {
    ufoEventOnboardingInviteUsers,
    ufoEventOnboardingWizardProjectCreationIncludingProvisioning
} from "@/components/signup/utils/ufo-events";

export const onRedirectSuccess = (template: string) => () => {
    ufoEventOnboardingWizardProjectCreationIncludingProvisioning.success({
        customData: {
            template
        }
    });
};

export const onRedirectFailure = (template: string, error: unknown) => () => {
    ufoEventOnboardingWizardProjectCreationIncludingProvisioning.failure({
        customData: {
            template
        },
        error
    });
};

export const onInviteUsersRedirectSuccessInvite = async () => {
    await ufoEventOnboardingInviteUsers.success();
};

export const onInviteUsersRedirectFailureInvite = async (error: unknown) => {
    await ufoEventOnboardingInviteUsers.success({
        error
    });
};
